import React, { useState, useEffect } from 'react';
import ParadiseMudNavbar from 'paradise-mud-navbar';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import 'paradise-mud-navbar/src/components/ParadiseMudNavbar.css';
import '../PersonalizedHeaderStyles.scss';

const Header = (props) => {
  const dispatch = useDispatch();
  const lenguageData = useSelector((state) => state.lenguage.lang);
  const user = useSelector((state) => state.user);

  const navigate = useNavigate();
  const location = useLocation();

  const hideMobileMenu = () => {
    const modal = document.querySelector('.paradise-mud-mobile-navbar-modal.visible');
    if (modal) modal.classList.remove('visible');
  };

  const goToHome = () => {
    hideMobileMenu();
    navigate('/');
  };

  const goToDatingHistory = () => {
    hideMobileMenu();
    navigate('/historia-cita');
  };

  const goToMyReports = () => {
    hideMobileMenu();
    navigate('/reporte');
  };

  const goToMyData = () => {
    hideMobileMenu();
    navigate('/paciente-datos');
  };

  const closeSession = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('auth_data');
    localStorage.removeItem('access_token');
    window.location.href = '/';
  };

  const navbarMainLogo = '/Logotipo_Centro.png';
  const mobileNavBarLinks = () => {
    return [
      {
        title: lenguageData === 'ES' ? 'Home' : 'Inicio',
        onClick: goToHome,
      },
      {
        title: lenguageData === 'ES' ? 'My dating history' : 'Mi historial de citas',
        onClick: goToDatingHistory,
      },
      {
        title: lenguageData === 'ES' ? 'My Reports' : 'Resultados',
        onClick: goToMyReports,
      },
      {
        title: lenguageData === 'ES' ? 'My data' : 'Mis datos',
        onClick: goToMyData,
      },
      {
        title: 'Cerrar Sesión',
        onClick: closeSession,
      },
    ];
  };
  return (
    <FlexContainer className={'flex-column myMainNavBar'}>
      {' '}
      <ParadiseMudNavbar
        navbarClassNames={['', 'm-hide text-14']}
        navbarLogos={[navbarMainLogo]}
        navbarLinks={[
          {
            title: 'Inicio',
            onClick: goToHome,
          },

          {
            title: 'Mi historial de citas',
            onClick: goToDatingHistory,
          },
          {
            title: 'Mis Resultados',
            onClick: goToMyReports,
          },
          {
            title: 'Mis datos',
            onClick: goToMyData,
          },
          {
            title: 'Cerrar Sesión',
            onClick: closeSession,
          },
        ]}
        navbarButtons={[]}
        linksPosition={'left'}
      />{' '}
      <ParadiseMudNavbar
        navbarClassNames={['block-navbar', 'd-hide']}
        navbarLogos={[navbarMainLogo]}
        navbarLinks={mobileNavBarLinks()}
        linksPosition={'left'}
      />{' '}
    </FlexContainer>
  );
};
export default Header;
